export const REGIONS = [
  { label: 'IAD (us-east-1)', value: 'us-east-1', description: 'NA' },
  { label: 'PDX (us-west-2)', value: 'us-west-2', description: 'FE' },
  { label: 'ZAZ (eu-south-2)', value: 'eu-south-2', description: 'EU' },
];

// API base URLs — injected at build time via webpack DefinePlugin.
// Values are set per stage in CDK deployTimeReplacements.
declare const API_BASE_IAD: string;
declare const API_BASE_PDX: string;
declare const API_BASE_ZAZ: string;

// TODO: Replace with actual beacon domains once DNS is configured
// e.g. 'https://iad.alpha.beacon.fintech.amazon.dev'
export const API_BASES: Record<string, Record<string, string>> = {
  Alpha: {
    'us-east-1': API_BASE_IAD,
    'us-west-2': API_BASE_PDX,
    'eu-south-2': API_BASE_ZAZ,
  },
  Beta: {
    'us-east-1': '',
    'us-west-2': '',
    'eu-south-2': '',
  },
  Gamma: {
    'us-east-1': '',
    'us-west-2': '',
    'eu-south-2': '',
  },
  Prod: {
    'us-east-1': '',
    'us-west-2': '',
    'eu-south-2': '',
  },
};

export const DEFAULT_STAGE = 'Alpha';
export const DEFAULT_REGION = 'us-east-1';

export const getApiBase = (stage: string, region: string): string => {
  const base = API_BASES[stage]?.[region];
  if (!base) {
    throw new Error(`No API base configured for stage/region: ${stage}/${region}`);
  }
  return base;
};

/** Returns only regions that have a deployed API base for the given stage */
export const getDeployedRegions = (stage: string) =>
  REGIONS.filter(r => API_BASES[stage]?.[r.value]);

export const STATUS_ORDER = [
  'RECEIVED', 'VALIDATION', 'TRANSFORMATION', 'OUTAGE',
  'SENT_TO_BANK', 'PAIN002_RECEIVED', 'PAIN002_PROCESSING',
  'CAMT053_RECEIVED', 'CAMT053_PROCESSING',
];
